import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Input } from './ui/input';
import { Badge } from './ui/badge';
import { Search, Users, TrendingUp, DollarSign } from 'lucide-react';

const ShadcnTest = () => {
  return (
    <div className="p-8 space-y-8 bg-background">
      <div className="text-center space-y-4">
        <h1 className="text-4xl font-bold text-foreground">
          🎉 shadcn/ui + Tailwind CSS Setup Complete!
        </h1>
        <p className="text-muted-foreground">
          All components are working correctly. Ready to redesign your admin dashboard!
        </p>
      </div>

      {/* Test Buttons */}
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">Button Variants</h2>
        <div className="flex gap-4 flex-wrap">
          <Button>Default Button</Button>
          <Button variant="secondary">Secondary</Button>
          <Button variant="outline">Outline</Button>
          <Button variant="destructive">Destructive</Button>
          <Button variant="ghost">Ghost</Button>
          <Button variant="link">Link</Button>
        </div>
      </div>

      {/* Test Metric Cards like your dashboard design */}
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">Dashboard Metric Cards</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Total Members</CardTitle>
              <Users className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">2,420</div>
              <p className="text-xs text-muted-foreground">
                <span className="text-green-600">+2.1% from last month</span>
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Active Groups</CardTitle>
              <TrendingUp className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">12</div>
              <p className="text-xs text-muted-foreground">
                <span className="text-green-600">+1 this week</span>
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Total Revenue</CardTitle>
              <DollarSign className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">$8,945</div>
              <p className="text-xs text-muted-foreground">
                <span className="text-green-600">+5.2% from last month</span>
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">Join Requests</CardTitle>
              <Users className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">23</div>
              <p className="text-xs text-muted-foreground">
                <span className="text-orange-600">+3 pending</span>
              </p>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Test Search Input */}
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">Search Component</h2>
        <div className="relative max-w-sm">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input 
            placeholder="Search communities..." 
            className="pl-8"
          />
        </div>
      </div>

      {/* Test Badges */}
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold">Badge Variants</h2>
        <div className="flex gap-2 flex-wrap">
          <Badge>Default</Badge>
          <Badge variant="secondary">Secondary</Badge>
          <Badge variant="destructive">Destructive</Badge>
          <Badge variant="outline">Outline</Badge>
        </div>
      </div>

      {/* Success Message */}
      <div className="text-center p-6 bg-green-50 dark:bg-green-900/20 rounded-lg border border-green-200 dark:border-green-800">
        <h3 className="text-lg font-semibold text-green-800 dark:text-green-400">
          ✅ Ready to Redesign Your Admin Dashboard!
        </h3>
        <p className="text-green-700 dark:text-green-300 mt-2">
          All shadcn/ui components, Tailwind CSS, and Lucide icons are working perfectly.
          Your YesodCoPilot admin interface can now be modernized with this tech stack.
        </p>
      </div>
    </div>
  );
};

export default ShadcnTest;
